import React, { useEffect, useState } from "react";

import * as DashboardServices from "../../services/dashboard.services";
import { useLocation, useNavigate, useParams, Link } from "react-router-dom";
import * as PatientService from "../../services/patient.services";
import { LOADER_TIMEOUT_TIME, ROLE, SORT_D } from "../../../../utils/Constants";
import { capitalizeFirstLetter, extractTime, formateDate, getFormatedTime, TrimText } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../admin/common/custompagination";
import Skeleton from "react-loading-skeleton";
import RecordNotFound from "../../../center/shared/recordNotFound";

export default function DoctorDashboard() {
    const [showDashboardCount, setShowDashboardCount] = useState({});
    const params = useParams();
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true);
    const [search, setSearch] = useState({});
    const [totalRecords, setTotalRecords] = useState(0);
    const [itemPerPage] = useState(10);
    const [offset, setOffsetPage] = useState(0);
    const [refreshList, setRefreshList] = useState(false);
    const [prevGlobalSearch, setPrevGlobalSearch] = useState("");
    const [globalSearch, setGlobalSearch] = useState("");
    const [sortConfig, setSortConfig] = useState({ column: "appointment_date", order: SORT_D });
    const [searchValue, setSearchValue] = useState("");
    const { t } = useTranslation();

    useEffect(() => {
        DashboardServices.Counts()
            .then((response) => {
                setShowDashboardCount(response && response.data ? response.data : {});
            })
            .catch((error) => {
                console.log("error ====> ", error);
            });
    }, []);

    useEffect(() => {
        setLoader(true);
        const formData = new FormData();
        if (Object.keys(search).length) {
            formData.append("search", JSON.stringify(search));
        }
        formData.append("global_search", globalSearch);
        let page = params.page;
        if (globalSearch) {
            if (prevGlobalSearch !== globalSearch || !prevGlobalSearch) {
                page = 1;
            }
            setPage(page);
        }
        formData.append("page", page);
        formData.append("per_page", itemPerPage);
        if (sortConfig) {
            formData.append("sort", JSON.stringify(sortConfig));
        }
        // formData.append("isUpcomingAppointments", true);
        PatientService.listAppointments(formData, ROLE.DOCTOR)
            .then((data) => {
                if (data && data.data) {
                    setList(data.data.list || []);
                    setPage(data.data.page);
                    navigate(`/doctor/dashboard/${data.data.page}`);
                    setOffsetPage(data.data.offset);
                    setTotalRecords(data.data.total_records || 0);
                } else {
                    setList([]);
                    setOffsetPage(0);
                    setTotalRecords(0);
                }
                setPrevGlobalSearch(globalSearch);
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            })
            .catch((error) => {
                console.log("error ====> ", error);
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            });
    }, [search, refreshList, globalSearch, params.page, sortConfig]);

    return (
        <>
            <main id="main-content">
                <div className="mt-4 ms-3 me-3">
                    <div className="dashboard-cards mb-4">
                        <div className="row">
                            <div className="col-md-4 d-flex">
                                <div className="card w-100">
                                    <div className="card-body d-flex align-items-center justify-content-between">
                                        <figcaption>
                                            <span>Today Appointments </span>
                                            <h4>{showDashboardCount?.todayAppointments}</h4>
                                        </figcaption>
                                        <figure className="card-icon-color-2">
                                            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M20.5 4.25V9.25M10.5 4.25V9.25M5.5 14.25H25.5M5.5 9.25C5.5 8.58696 5.76339 7.95107 6.23223 7.48223C6.70107 7.01339 7.33696 6.75 8 6.75H23C23.663 6.75 24.2989 7.01339 24.7678 7.48223C25.2366 7.95107 25.5 8.58696 25.5 9.25V24.25C25.5 24.913 25.2366 25.5489 24.7678 26.0178C24.2989 26.4866 23.663 26.75 23 26.75H8C7.33696 26.75 6.70107 26.4866 6.23223 26.0178C5.76339 25.5489 5.5 24.913 5.5 24.25V9.25ZM10.5 19.25H13V21.75H10.5V19.25Z"
                                                    stroke="white"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                        </figure>
                                    </div>
                                    <Link to={`/doctor/consultation-history/1`} className="stretched-link"></Link>
                                </div>
                            </div>
                            <div className="col-md-4 d-flex">
                                <div className="card w-100">
                                    <div className="card-body d-flex align-items-center justify-content-between">
                                        <figcaption>
                                            <span>Total Patients</span>
                                            <h4>{showDashboardCount?.totalPatients}</h4>
                                        </figcaption>
                                        <figure className="card-icon-color-3">
                                            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M4.25 26.75V24.25C4.25 22.9239 4.77678 21.6521 5.71447 20.7145C6.65215 19.7768 7.92392 19.25 9.25 19.25H14.25C15.5761 19.25 16.8479 19.7768 17.7855 20.7145C18.7232 21.6521 19.25 22.9239 19.25 24.25V26.75M20.5 4.41251C21.5755 4.68788 22.5288 5.31338 23.2095 6.19039C23.8903 7.06741 24.2598 8.14604 24.2598 9.25626C24.2598 10.3665 23.8903 11.4451 23.2095 12.3221C22.5288 13.1991 21.5755 13.8246 20.5 14.1M26.75 26.75V24.25C26.7437 23.1465 26.3724 22.076 25.6941 21.2055C25.0158 20.335 24.0685 19.7134 23 19.4375M6.75 9.25C6.75 10.5761 7.27678 11.8479 8.21447 12.7855C9.15215 13.7232 10.4239 14.25 11.75 14.25C13.0761 14.25 14.3479 13.7232 15.2855 12.7855C16.2232 11.8479 16.75 10.5761 16.75 9.25C16.75 7.92392 16.2232 6.65215 15.2855 5.71447C14.3479 4.77678 13.0761 4.25 11.75 4.25C10.4239 4.25 9.15215 4.77678 8.21447 5.71447C7.27678 6.65215 6.75 7.92392 6.75 9.25Z"
                                                    stroke="white"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                        </figure>
                                    </div>
                                    <Link to={`/doctor/settings/patient/1`} className="stretched-link"></Link>
                                </div>
                            </div>
                            <div className="col-md-4 d-flex">
                                <div className="card w-100 position-relative">
                                    <div className="card-body d-flex align-items-center justify-content-between">
                                        <figcaption>
                                            <span>Total Appointments</span>
                                            <h4>{showDashboardCount?.totalAppointments}</h4>
                                            {/* <h4>₹{showDashboardCount.walletBalance}</h4> */}
                                        </figcaption>
                                        <figure className="card-icon-color-1">
                                            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M21.75 10.5V6.75C21.75 6.41848 21.6183 6.10054 21.3839 5.86612C21.1495 5.6317 20.8315 5.5 20.5 5.5H8C7.33696 5.5 6.70107 5.76339 6.23223 6.23223C5.76339 6.70107 5.5 7.33696 5.5 8M5.5 8C5.5 8.66304 5.76339 9.29893 6.23223 9.76777C6.70107 10.2366 7.33696 10.5 8 10.5H23C23.3315 10.5 23.6495 10.6317 23.8839 10.8661C24.1183 11.1005 24.25 11.4185 24.25 11.75V15.5M5.5 8V23C5.5 23.663 5.76339 24.2989 6.23223 24.7678C6.70107 25.2366 7.33696 25.5 8 25.5H23C23.3315 25.5 23.6495 25.3683 23.8839 25.1339C24.1183 24.8995 24.25 24.5815 24.25 24.25V20.5M25.5 15.5V20.5H20.5C19.837 20.5 19.2011 20.2366 18.7322 19.7678C18.2634 19.2989 18 18.663 18 18C18 17.337 18.2634 16.7011 18.7322 16.2322C19.2011 15.7634 19.837 15.5 20.5 15.5H25.5Z"
                                                    stroke="white"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                        </figure>
                                    </div>
                                    <Link to={`/doctor/consultation-history/1`} className="stretched-link"></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-body">
                            <h3 className="mb-4">Recent Appointments</h3>
                            <div className="table-responsive mt-2">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Appointment ID</th>
                                            <th>Date</th>
                                            <th>Time</th>
                                            <th>Patient Name</th>
                                            <th>Major Concern</th>
                                            <th>Phone Number</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loader ? (
                                            <td colSpan={7}>
                                                <Skeleton className="mb-2" height={50} count={5} />
                                            </td>
                                        ) : list?.length ? (
                                            list.map((appointment, index) => (
                                                <tr key={index}>
                                                    <td>{appointment.appointment_register_id ? "#" + appointment.appointment_register_id : null}</td>
                                                    <td>{formateDate(appointment?.appointment_date)}</td>
                                                    {/* <td>{appointment?.start_time}</td> */}
                                                    <td>{extractTime(appointment?.appointment_date)}</td>
                                                    <td>{capitalizeFirstLetter(TrimText(appointment?.patient_name, 30))}</td>
                                                    <td>{capitalizeFirstLetter(TrimText(appointment?.major_concern, 30))}</td>
                                                    <td>{appointment?.patient_phone_no}</td>
                                                    <td>{capitalizeFirstLetter(appointment?.status === "canceled" ? "Cancelled" : appointment?.status)}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <td colSpan={7}>
                                                <RecordNotFound heading="center.staff.no_staff_found" />
                                            </td>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="table-status-info d-flex justify-content-between align-items-center">
                                <span>
                                    {t("center.staff.label_showing")} {offset + list.length} of {totalRecords} {t("center.staff.label_entries")}
                                </span>
                                <nav aria-label="Page navigation example" title={page}>
                                    {totalRecords && totalRecords > 0 ? (
                                        <CustomPagination
                                            datalength={totalRecords}
                                            itemperpage={itemPerPage}
                                            currentPage={page}
                                            custompath="page"
                                            setPage={setPage}
                                            pageRoute={[{ name: "dashboard", path: "/doctor/dashboard" }]}
                                        />
                                    ) : (
                                        ""
                                    )}
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}
